import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ItemAttributesService } from '../../../services/item-attributes.service';
import { UserIdToNamePipe } from '../../../pipes/user-id-to-name.pipe';
import { ToastrService } from 'ngx-toastr';
import { AttributeValuePipe } from '../../attribute-value.pipe';
import { AttributeValueTimestampUserPipe } from '../../attribute-value-timestamp-user.pipe';
import { MatButton } from '@angular/material/button';
import { AttributeValueInputComponent } from '../../attribute-value-input/attribute-value-input.component';
import { KeyValuePairComponent } from '../../../general/key-value-pair/key-value-pair.component';
import { NgFor, AsyncPipe } from '@angular/common';
import { TestIdDirective } from '../../../directives/test-id.directive';

@Component({
    selector: 'app-tracked-attributes-prompt-dialog',
    templateUrl: './tracked-attributes-prompt-dialog.component.html',
    providers: [UserIdToNamePipe],
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, TestIdDirective, ReactiveFormsModule, NgFor, KeyValuePairComponent, AttributeValueInputComponent, MatDialogActions, MatButton, MatDialogClose, AsyncPipe, AttributeValueTimestampUserPipe, AttributeValuePipe]
})
export class TrackedAttributesPromptDialogComponent {
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuild: FormBuilder,
    private dialogRef: MatDialogRef<TrackedAttributesPromptDialogComponent>,
    private itemAttributeService: ItemAttributesService,
    private toastr: ToastrService
  ) {
    this.form = this.formBuild.group({
      attributes: this.formBuild.array(
        this.data.attributes.map((attr) => {
          return this.formBuild.group({
            attribute_id: attr.id,
            value: this.formBuild.control('', Validators.required)
          });
        })
      )
    });
  }

  save() {
    const eventInsert = {
      attributes: this.form.value.attributes,
      promptable_type: this.data.promptableType,
      promptable_id: this.data.promptableId,
      event: this.data.event
    };
    this.itemAttributeService
      .eventInsert(this.data.itemId, eventInsert)
      .subscribe((res) => {
        this.toastr.success('Attributes updated');
        this.dialogRef.close(res);
      });
  }
}
